<p>
  <ng-container i18n="@@auth-module|slack|page-redirect-info"
    >Page will redirect in a few seconds.
  </ng-container>
  <db-dot-loader i18n="@@auth-module|slack|please-wait"
    >Please wait</db-dot-loader
  >
</p>
